import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Loading from '../../Shared/Loading'
import EmptyState from '../../Shared/EmptyState'
import Button from '../../Shared/Button'

import { getService } from '../../../ducks/addons'

class AddonsDetailsModal extends Component {
  getInstallURL = () => {
    const { match } = this.props
    const { appId, serviceId } = match.params

    return `/apps/${appId}/addons/install/${serviceId}`
  }

  render() {
    const { service } = this.props

    if (!service) {
      return (
        <EmptyState greedy>
          <Loading large />
        </EmptyState>
      )
    }

    return (
      <div className="addons-modal-content">
        <div className="addons-modal-header">
          <div className="addons-modal-header-actions">
            <Button to={this.getInstallURL()}>Install Now</Button>
          </div>
          <h3>{service.name}</h3>
          <p>{service.tagline}</p>
        </div>
        <div className="addons-modal-details">
          <p className="addons-modal-description">{service.description}</p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, { serviceId }) => ({
  service: getService(state, serviceId),
})

export default withRouter(connect(mapStateToProps)(AddonsDetailsModal))
